import {
  parseCheckoutError
} from "./chunk-WWLG26XU.mjs";
import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/subscriptions/checkout.ts
import { getLocaleOnly } from "@wbk/utils";
import { CheckoutException } from "@wbk/logger";
var checkoutSubscription = (_0) => __async(void 0, [_0], function* ({ order, usePaymentApi, email, locale }) {
  var _a, _b;
  try {
    const lang = getLocaleOnly(locale);
    const data = yield fetchClient({
      baseUrl: usePaymentApi ? (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.paymentApi : void 0,
      url: `/subscriptions/upgrade-plan?lang=${lang}`,
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues({}, order), { lang }))
      }
    });
    if (!data.redirect_url) {
      throw new Error("Missing redirect url");
    }
    return data.redirect_url;
  } catch (error) {
    const err = error;
    const possibleTicketErrors = parseCheckoutError(err);
    throw new CheckoutException({
      error: err,
      order: __spreadProps(__spreadValues({}, order), { email }),
      ticketErrors: possibleTicketErrors
    });
  }
});
var checkoutStreamingWithCredit = (_0) => __async(void 0, [_0], function* ({
  order,
  usePaymentApi,
  email,
  locale
}) {
  var _a, _b, _c, _d;
  try {
    const lang = getLocaleOnly(locale);
    const data = yield fetchClient({
      baseUrl: usePaymentApi ? (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.paymentApi : void 0,
      url: `/streaming/checkout?lang=${lang}`,
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues({}, order), { lang }))
      }
    });
    if (((_c = data == null ? void 0 : data.status) == null ? void 0 : _c.toLowerCase()) !== "success") {
      const possibleObj = typeof (data == null ? void 0 : data.message) === "object" ? data == null ? void 0 : data.message : { message: ((_d = data == null ? void 0 : data.error) == null ? void 0 : _d.message) || (data == null ? void 0 : data.message) };
      const msg = Object.values(possibleObj || {})[0];
      const msgString = Array.isArray(msg) ? msg[0] : msg;
      throw new Error(msgString || "Something went wrong");
    }
    if (!data.data.order_id) {
      throw new Error("checkoutStreamingWithCredit with no order_id");
    }
    return data.data;
  } catch (error) {
    const err = error;
    const possibleTicketErrors = parseCheckoutError(err);
    throw new CheckoutException({
      error: err,
      order: __spreadProps(__spreadValues({}, order), { email }),
      ticketErrors: possibleTicketErrors
    });
  }
});

export {
  checkoutSubscription,
  checkoutStreamingWithCredit
};
//# sourceMappingURL=chunk-BDC2UVDS.mjs.map